import { lazyLoad } from 'utils/loadable';

export const MaterialFormPage = lazyLoad(
  () => import('./index'),
  module => module.MaterialFormPage,
);
